import * as React from 'react';
import {useSelector} from 'react-redux';
import {selectFormApiError, selectBrand} from 'src/selectors/referral-external';
import type {QuestionApiError} from 'src/types/referral-external';
import {type ElementContext, useRoutes} from 'src/rerouter';
import ReferralErrorComponent from 'src/components/referral-external/referral-external-error';
import {ReferralExternalWrapper} from 'src/components/referral-external/referral-external-wrapper';
import {REFERRAL_URL_SEGMENT} from 'src/utils/referral-external';


export default function ReferralRoutes() {
  // @ts-expect-error - TS2739 - Type 'JobDescription' is missing the following properties from type 'QuestionApiError': agency_link, status
  const questionApiErrorData: QuestionApiError =
    useSelector(selectFormApiError);

  const brand = useSelector(selectBrand);

  const [content] = useRoutes([
    {
      path: `${REFERRAL_URL_SEGMENT}:referralLinkId`,
      element: questionApiErrorData ? (
        <ReferralErrorComponent
          status={questionApiErrorData.status}
          agency_link={questionApiErrorData.agency_link}
          buttonColor={brand?.button_color}
        />
      ) : (
        (context: ElementContext) => {
          /** we need to provide it from router context because
           * client side navigation using <Link> component updates values
           * in the context
           */
          const {referralLinkId} = context.params;
          // const isError = Boolean(props.error);
          const {
            action,
            source_email,
            token,
            uid,
            iframe,
            utm_source,
            utm_medium,
          } = context.location.query;
          const params = {
            referralLinkId,
            action,
            sourceEmail: decodeURIComponent(source_email),
            token,
            uid,
            isIframe: JSON.parse(iframe || 'false'),
            utm_source,
            utm_medium,
          } as const;
          return <ReferralExternalWrapper params={params} />;
        }
      ),
    },
  ]);

  return content;
}
